import {axiosApiInstance} from '../axios';

export const newTrustScore = (formData) =>{
    return axiosApiInstance.post(`/admin/trust-score/new` , formData);
}

export const singleTrustScore = (id) =>{
    return axiosApiInstance.get(`/admin/trust-score/edit/${id}`);
}

export const editTrustScore = (id , formData) =>{
    return axiosApiInstance.put(`/admin/trust-score/${id}` , formData);
}

export const removeTrustScore = (id) =>{
    return axiosApiInstance.delete(`/admin/trust-score/${id}`);
}


